import i18n from 'i18next';

import { registerValidator } from 'core/forms';

const isUntilRequired = ({
  fieldValue,
}) => {
  if (fieldValue.frequency && !fieldValue.until) {
    return {
      hasError: true,
      error: i18n.t('agenda-until-field-error'),
    };
  }

  return { hasError: false };
};

registerValidator('isUntilRequired', isUntilRequired);

export default isUntilRequired;
